import React from 'react';
import PropTypes from 'prop-types';

const FiltersHead = ({ categoryName, count }) => (
  <h2 className='ken-plp__filters__title ken-wrapper--big-grid'>
    {categoryName}&nbsp;<span className='--count'>({count})</span>
  </h2>
);

FiltersHead.propTypes = {
  categoryName: PropTypes.string,
  count: PropTypes.number,
};

FiltersHead.defaultProps = {
  categoryName: '...',
  count: 0,
};

export default FiltersHead;
